import Style from "./Navbar.module.scss";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../firebase";

import { useState, useRef, useEffect } from "react";

const Navbar = ({ logout, userDetails }) => {
	const [user, loading, error] = useAuthState(auth);
	const [name, setName] = useState("");
	const [email, setEmail] = useState("");

	const [dropdownActive, setDropdownActive] = useState(false);
	const dropDownRef = useRef();

	useEffect(() => {
		const checkIfClickedOutside = (e) => {
			if (
				dropdownActive &&
				dropDownRef.current &&
				!dropDownRef.current.contains(e.target)
			) {
				setDropdownActive(false);
			}
		};

		document.addEventListener("mousedown", checkIfClickedOutside);

		return () => {
			document.removeEventListener("mousedown", checkIfClickedOutside);
		};
	}, [dropdownActive]);

	return (
		<div className={Style.navbar}>
			<div className={Style.content}>
				<div className={Style.logo}>Photoboard</div>

				{/* <div>
				{userDetails?.name}
				{userDetails?.email}
				<button onClick={logout} className={Style.logout}>Log out</button>
				</div> */}

				<div className={Style["profile-right"]}>
					<div ref={dropDownRef}>
						<img
							className={Style.profile}
							src={`https://source.boringavatars.com/beam/120/${userDetails?.name}?colors=FFAB03,FC7F03,FC3903,D1024E,A6026C`}
							alt="User avatar"
							onClick={() => setDropdownActive(!dropdownActive)}
						></img>
						{/* {dropdownActive && ( */}
						<div
							className={
								dropdownActive
									? `${Style["dropdownWrapper"]} 
						${Style.active}
						`
									: `${Style["dropdownWrapper"]} `
							}
							id="dropdownWrapper"
							style={{ width: "max-content" }}
						>
							{/* <div className={Style.arrow}></div> */}
							<div className={Style["dropdown-profile-details"]}>
								<span className={Style["dropdown-profile-details--name"]}>
									{userDetails?.name}
								</span>
								<span className={Style["dropdown-profile-details--email"]}>
									{userDetails?.email}
								</span>
							</div>
							<div className={Style["dropdown-links"]}>
								{/* <a href="#">Profile</a> */}
								<a href="#" onClick={logout}>
									Sign out
								</a>
							</div>
						</div>
						{/* )} */}
					</div>
				</div>
			</div>
		</div>
	);
};

export default Navbar;
